export default __webpack_public_path__ + "static/media/funhorse.430f3d31.svg";